import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Component({
	selector: 'app-google-auth',
	templateUrl: './google-auth.component.html',
})
export class GoogleAuthComponent implements OnInit, OnDestroy {
	token = '';

	private readonly destroy$ = new Subject<void>();

	constructor(private readonly route: ActivatedRoute) {}

	ngOnInit(): void {
		this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((params) => {
			this.token = params?.code;
		});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
